import { render, staticRenderFns } from "./u-select-filled-pill.vue?vue&type=template&id=547a776c&scoped=true"
import script from "./u-select-filled-pill.vue?vue&type=script&lang=js"
export * from "./u-select-filled-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a776c",
  null
  
)

export default component.exports